import {light} from './light';


export const themes = {
    light
};